import PropTypes from "prop-types";
import {Button} from "react-bootstrap";

export function ButtonCustom(props) {
    const {title, onClick, className,btnSmall} = props;
    return <Button className={className? className : "btn-light shadow border border-black "} onClick={() => onClick()}>{title}</Button>

}

ButtonCustom.propTypes = {
    title: PropTypes.string, onClick: PropTypes.func, className: PropTypes.string
};